<style  lang="scss" scoped>
.my-input{
    height: 100%;
    /deep/.el-input{
        border: 0;
        padding: 0;
        height: 100%;
         .el-input__inner{
            height: 98%;
            border: 0px solid #dcdfe6;
            border-radius: 0px;
            text-align: center;
            // padding: 0;

        }
        .get-focus{
            border: 1px solid #dcdfe6;
            border-radius: 0px;
        }
    }
}
</style>

<template>
    <div class="my-input">
        <el-input v-model="value" placeholder="请输入" size="small" @focus="getfocus($event)" @blur="dblur($event)" @keydown.native="channelInputLimit($event)" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value:this.data,
            pasteBeforeValue:"",
            pasteFlag:false
        };
    },
    props: {
        maxLength:{
			type: Number,
			default: function(){
				return 17
			}
        },
        index:{
			type: Number,
			default: function(){
				return 0
			}
        },
        field:{
			type: String,
			default: function(){
				return ""
            }
        },
        data:{
			type: String,
			default: function(){
				return ""
			}
        }
    },
    watch: {
        data(newValue,oldValue){
            if(newValue != oldValue){
                this.value = this.commafy(newValue);
            }
        }
    },
    methods: {
        substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
        onPaste(){
            this.pasteBeforeValue = this.value;
                navigator.clipboard.readText().then((clipText)=>{
                    // console.log(JSON.stringify(clipText))
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]);
                        this.value=result[0][0];
                        this.$emit("change", {value:"",index:this.index,field:this.field,way:"paste",result:result});
                    }else{
                        this.value=this.pasteBeforeValue;
                    }
                });
        },
        //去除千分位
        delcommafy(num){
            if((num+"").trim()==""){
                return num;
            }
            num = num+"";
            num=num.replace(/,/gi,'');
            return num;
        },
        // 数字格式转换成千分位
        commafy(num){
            if((num+"").trim()=="" || isNaN(num) || num == null){
                return num;
            }
            num = num+"";
            if(/^.*\..*$/.test(num)){
            let pointIndex =num.lastIndexOf(".");
            let intPart = num.substring(0,pointIndex);
            let pointPart =num.substring(pointIndex+1,num.length);
            intPart = intPart +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(intPart)){
                intPart =intPart.replace(re,"$1,$2")
                }
            num = intPart+"."+pointPart;
            }else{
                num = num +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(num)){
                num =num.replace(re,"$1,$2")
                }
            }
            return num;
        },
        getfocus(e){
            this.pasteFlag = false;
            e.target.type="number";
            this.$nextTick(()=>{
                setTimeout(()=>{
                    e.target.type="text";
                    e.target.value = this.value;
                    e.target.selectionStart = e.target.value.length;
                },100);
            });
            this.getFocusKeydown(e);
            e.target.className = 'get-focus el-input__inner';
        },
        //键盘监控
        getFocusKeydown(e){
            let that = this;
            $(e.target).keydown(function(e) {
                if (e.ctrlKey && (e.keyCode == 86)){
                    that.onPaste();
                    that.pasteFlag = true;
                } 
                
            });
        },
        dblur(e){
            this.$emit("change", {value:this.delcommafy(this.value),index:this.index,field:this.field});
            e.target.value = this.commafy(e.target.value);
            e.target.type="text";
            e.target.className = 'el-input__inner';
            //清除keydown事件
            $(e.target).unbind();
        },
         // 圆角问题
        inputQue(key,e,selectionStart){
            //光标问题
            let eselectionStart = e.target.selectionStart;
            let eselectionEnd = e.target.selectionEnd;
                setTimeout(() => {
                    let position=selectionStart;
                    if(key != "Backspace"){
                        position = selectionStart+1;
                    }else{
                        
                        if(eselectionEnd - eselectionStart != 0){
                            position = e.target.selectionStart;
                        }
                    }
                e.target.selectionStart =position;
                e.target.selectionEnd =position;
            }, 10);
            let code =e.code.replace(/[^0-9]/ig,"");
            if(key === '.'){
                code=".";
            }
            if(key === "Backspace"){
                this.value = this.value.slice(0, selectionStart) + this.value.slice(selectionStart+1);
            }else{this.value
                this.value = this.value.slice(0, selectionStart) + code + this.value.slice(selectionStart);
            }
        },
        channelInputLimit(e){
            if(this.pasteFlag) return;
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            // let rowprop = this.value;
            // e.target.selectionStart=e.target.selectionEnd=rowprop.length
            // e.target.type="number";
            let key = e.key;
            let ctrlKey=e.ctrlKey
            //限制长度
            if(this.value.length> this.maxLength && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //小数点前十五位判断
            let index = this.value.indexOf(".");
            let selectionStart=e.target.selectionStart;
            if(key === "Backspace"){
                selectionStart = selectionStart-1;
            }
            if((index == -1 && this.value.length > this.maxLength-3 && key !== "Backspace" && key !== ".")|| (index>-1&&index == this.maxLength-2&&index>=selectionStart && key !== "Backspace")){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //整数的时候 不能输入小数点
            // if(col.isInteger && (key === '.'|| key === 'Decimal')){
              
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
            var reg = /^\d+$|^\d*\.\d+$/g;
            if (key === '.' || key === 'Decimal' ) {
                if(  this.value == ""  || this.value.toString().indexOf('.') !=-1){
                   e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    return false;
                }else{
                    this.inputQue(key,e,selectionStart);
                    return true;
                }
            }
             this.inputQue(key,e,selectionStart);
            // else if(reg.test(key) || key === "Backspace" || (row.isFuShu && (key === 'Process' || key==='-'))){
            //     this.tempkey = "";
            //     return true;
            // }
            // else{
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
        },
    }
};
</script>
<style scoped>
</style>